/**
 * Query segment for email routes that accept optional `partitionAt` (composite PK with id).
 * Returns empty string or `?partitionAt=...` (encoded ISO).
 */
export function emailPartitionAtSearch(partitionAt?: string | null): string {
  if (partitionAt == null || partitionAt === '') return '';
  return `?partitionAt=${encodeURIComponent(partitionAt)}`;
}

/** Full path to email detail including partition when known (shareable URL). */
export function emailDetailPath(id: number, partitionAt?: string | null): string {
  return `/emails/${id}${emailPartitionAtSearch(partitionAt)}`;
}

/** Reply / reply-all / forward path with partition query when known. */
export function emailComposeThreadPath(
  id: number,
  kind: 'reply' | 'reply-all' | 'forward',
  partitionAt?: string | null
): string {
  return `/emails/${id}/${kind}${emailPartitionAtSearch(partitionAt)}`;
}

/** Compose URL for "edit as new" with optional partition for GET /emails/:id when state is missing. */
export function composeEditAsNewQuery(id: number, partitionAt?: string | null): string {
  const params = new URLSearchParams();
  params.set('editAsNew', String(id));
  if (partitionAt) params.set('editAsNewPartitionAt', partitionAt);
  return `?${params.toString()}`;
}

/** Inbox deep link: open an email and the Collaboration drawer (e.g. from mention notifications). */
export function emailCollaborationInboxPath(id: number, partitionAt?: string | null): string {
  const params = new URLSearchParams();
  params.set('emailId', String(id));
  params.set('collaboration', '1');
  if (partitionAt) params.set('partitionAt', partitionAt);
  return `/emails?${params.toString()}`;
}
